import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Input from '../Input/Input';
import Button from '../Button/Button';

import styles from './ContactForm.css';

export default class ContactForm extends Component {

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.submitAction = this.submitAction.bind(this);

    this.state = {
      email: '',
      name: '',
      message: '',
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const { settings } = this.state;

    this.setState({
      [name]: value
    });
  }

  submitAction(e) {
    const { sendAction } = this.props;

    console.log(this.state);

    e.preventDefault();

    sendAction({ email: this.state.email, name: this.state.name, message: this.state.message });
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <form onSubmit={this.submitAction}>

          <Row>
            <Col xs={12} md={12}>
              <label>Ihre Emailadresse</label>
              <Input
                type="text"
                name="email"
                placeholder=""
                light
                onChange={this.handleInputChange}
                autocomplete="off"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <label>Ihr Name</label>
              <Input
                type="text"
                name="name"
                placeholder=""
                light
                onChange={this.handleInputChange}
                autocomplete="off"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <label>Wie können wir Ihnen weiterhelfen?</label>
              <Input
                type="textarea"
                name="message"
                placeholder=""
                light
                onChange={this.handleInputChange}
                autocomplete="off"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Button submit pullRight>Absenden</Button>
            </Col>
          </Row>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js